import React from 'react';
import playMarket from '../../_assets/images/playMarket.png';

function MarketPlay() {
  const url = 'https://play.google.com/store/apps/details?id=kz.smartdana.smartdana';
  return (
    <a href={url} download>
      <img alt="" src={playMarket} />
    </a>
  );
}

export default MarketPlay;
